import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

export default function SchedulerPage() {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [message, setMessage] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = async () => {
    try {
      const { data } = await apiClient.get('/clients');
      setClients(data || []);
      if (!selectedClient && Array.isArray(data) && data.length) {
        setSelectedClient(data[0].id);
      }
    } catch (error) {
      console.error('Ошибка загрузки кабинетов:', error);
      setMessage('Не удалось загрузить клиентов');
    }
  };

  const runScheduler = async () => {
    if (!selectedClient) {
      setMessage('Выберите клиента');
      return;
    }

    setLoading(true);
    setMessage('Запускаем scheduler...');
    try {
      const { data } = await apiClient.post(`/schedule/run/${selectedClient}`);
      setResult(data);
      setMessage(data.processed ? `Обработано ${data.processed} кампаний` : 'Scheduler запущен');
    } catch (error) {
      console.error('Ошибка scheduler:', error);
      setMessage(error.response?.data?.message || 'Ошибка при запуске scheduler');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 max-w-3xl mx-auto p-6 space-y-6">
      <h2 className="text-2xl font-bold">Scheduler кампаний Wildberries</h2>
      <div className="space-y-2">
        <label className="text-sm font-semibold">Клиент:</label>
        <select
          className="glass-input w-full"
          value={selectedClient}
          onChange={(e) => setSelectedClient(e.target.value)}
        >
          <option value="">-- Выберите клиента --</option>
          {clients.map((account) => (
            <option key={account.id} value={account.id}>
              {account.name || `Клиент ${account.id}`}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={runScheduler}
        disabled={loading}
        className="glass-btn w-full py-3 disabled:opacity-60"
      >
        {loading ? 'Запуск...' : 'Выполнить scheduler'}
      </button>

      {message && <p className="text-sm text-gray-600">{message}</p>}

      {result?.details?.length > 0 && (
        <div className="glass-card p-5">
          <h3 className="font-semibold mb-2 text-gray-800">Корректировки:</h3>
          <ul className="space-y-2">
            {result.details.map((entry) => (
              <li key={`${entry.campaign_id}-${entry.advert_id}`}>
                Кампания {entry.advert_id}: статус <strong>{entry.targetStatus}</strong>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
